import { render, staticRenderFns } from "./SwitchCurrency.vue?vue&type=template&id=30c2e83a&scoped=true&"
import script from "./SwitchCurrency.vue?vue&type=script&lang=ts&"
export * from "./SwitchCurrency.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchCurrency.vue?vue&type=style&index=0&id=30c2e83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2e83a",
  null
  
)

export default component.exports